import UWWlogoPng from "/UWWlogo.png";
import backgroundGlowPng from "/backgroundGlow.png";

export default function Hello() {
	return (
		<div className="title">
			<section>
				<img src={UWWlogoPng} width={200} height={155} alt="Logo" />
			</section>
			<section>
				<h1>UNCLE WALLY'S WORLD</h1>
				<h5>
					<span style={{ color: "violet" }}>#LET'S</span>
					<span style={{ color: "skyblue" }}>COLOR</span>
					<span style={{ color: "slateblue" }}>THE</span>
					<span style={{ color: "peach" }}>WORLD</span>
				</h5>
				<h5>
					<span style={{ color: "red" }}>#LOVEMAKESTHEWORLDGOROUNDTOUR</span>
				</h5>
				<a href="https://www.youtube.com/watch?v=Jou9ZUG67K0">
					<img src={backgroundGlowPng} alt="Logo" />
				</a>
				<h4>THE HEART OF THE VISION, CIRCA 2014!</h4>
				<a href="https://www.youtube.com/watch?v=Jou9ZUG67K0" target="_blank">
					CLICK HERE
				</a>
			</section>
		</div>
	);
}
